<!--
  Created 15.06.2023
  Simple reusable modal component, should not contain any logic
-->
<template>
  <teleport to="body">
    <transition leave-active-class="duration-200">
      <div
        v-show="showModal"
        class="fixed inset-0 flex items-center justify-center overflow-y-auto print:!hidden"
        :class="zIndexClass">
        <transition
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0">
          <!-- eslint-disable tailwindcss/migration-from-tailwind-2 -->
          <div
            v-show="showModal"
            class="fixed inset-0 transform transition-all"
            :class="{'cursor-pointer': outsideClick}"
            @click="() => { if (outsideClick) showModal=false }">
            <div class="absolute inset-0 bg-gray-500 opacity-75" />
          </div>
          <!-- eslint-enable tailwindcss/migration-from-tailwind-2 -->
        </transition>
        <transition
          enter-active-class="ease-out duration-300"
          enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-active-class="ease-in duration-200"
          leave-from-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <!-- eslint-disable tailwindcss/migration-from-tailwind-2 -->
          <div
            v-show="showModal"
            class="transform shadow-xl transition-all"
            :class="boxClass">
            <!-- eslint-enable tailwindcss/migration-from-tailwind-2 -->
            <div class="h-full w-full overflow-hidden rounded-xl bg-white">
              <XMarkIcon
                class="absolute right-1 top-1 z-[60] h-8 w-8 cursor-pointer p-0.5 pb-1 text-gray-500 hover:text-gray-800"
                aria-hidden="true"
                @click="showModal=false" />

              <!-- Slot -->
              <slot name="content" />
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import {
  computed, onUnmounted, watch,
} from 'vue';
import {
  XMarkIcon,
} from '@heroicons/vue/24/outline';

const emit = defineEmits(['update:show']);

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
    default: false,
  },
  boxClass: {
    type: [String, Array],
    required: false,
    default: 'w-3/5 h-3/5',
  },
  zIndexClass: {
    type: String,
    required: false,
    default: 'z-50',
  },
  outsideClick: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const showModal = computed({
  get() {
    return props.show;
  },
  set(value) {
    emit('update:show', value);
  },
});

watch(() => showModal.value, (value) => {
  if (value === true) {
    document.body.classList.add('modal-open');
  } else {
    document.body.classList.remove('modal-open');
  }
});

onUnmounted(() => {
  document.body.classList.remove('modal-open');
});

</script>

<style lang="scss">
body.modal-open {
  overflow: hidden;
}
</style>
